export default[
    {
        path: '/dataList/memberCardTrade',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '会员卡交易数据',
            authLogin: true
        }
    },
]